var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-col',[_c('v-row',[_c('financial-statistics')],1),_c('v-row',[_c('invoicing',{staticClass:"mt-n5"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }